var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk25843430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145.4 30",
    style: {
      enableBackground: "new 0 0 145.4 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 1.7789 22.2548)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 4.1874 49.922)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,30H28.8V0H59V30z M30,28.8h27.8V1.2H30V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,25.9H32.3V3.7H55V25.9z M33.4,24.8h20.5v-20H33.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.6,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 11.9382 62.902)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 47.5852 124.8605)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.1,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,30h-30.1V0h30.1V30z M116.4,28.8h27.8V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.4,25.9h-22.8V3.7h22.8V25.9z M119.8,24.8h20.5v-20h-20.5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.9,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.5631 49.3981)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 33.1658 99.9612)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,30H86.5V0h30.1V30z M87.7,28.8h27.8V1.2H87.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.7,25.9H90V3.7h22.8V25.9z M91.1,24.8h20.5v-20H91.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 5.154 35.7587)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 18.6066 74.8211)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.4,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7,30H57.6V0h30.1V30z M58.7,28.8h27.8V1.2H58.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,25.9H61V3.7h22.8V25.9z M62.1,24.8h20.5v-20H62.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 -1.6132 8.683)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.8,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -10.3015 24.9026)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0V0h30.1V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,25.9H3.4V3.7h22.8V25.9z M4.6,24.8H25v-20H4.6V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,29.6l-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l1-2.1c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-1,2.1 C1.5,29.5,1.3,29.6,1.1,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,24.6l-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2-3.9c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-2,3.9 C4,24.5,3.8,24.6,3.6,24.6z M7.1,17.7l-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2-3.9c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8 l-2,3.9C7.5,17.6,7.3,17.7,7.1,17.7z M10.5,10.9l-0.3-0.1C10,10.7,9.8,10.3,10,10l2-3.9c0.1-0.3,0.5-0.4,0.8-0.3 C13,6,13.1,6.3,13,6.6l-2,3.9C10.9,10.7,10.7,10.9,10.5,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9,4l-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l1-2.1c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-1,2.1 C14.3,3.9,14.1,4,13.9,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8,29.6c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4.1c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l2.1,4.1c0.1,0.3,0,0.6-0.3,0.8 L28.8,29.6z M25.2,22.4c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4.1c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l2.1,4.1 c0.1,0.3,0,0.6-0.3,0.8L25.2,22.4z M21.6,15.2c-0.2,0-0.4-0.1-0.5-0.3L19,10.7c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3 l2.1,4.1c0.1,0.3,0,0.6-0.3,0.8L21.6,15.2z M18,7.9c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4.1c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3 l2.1,4.1c0.1,0.3,0,0.6-0.3,0.8L18,7.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk25843430);
export default __webpack_public_path__ + "static/media/AK2_5_84343_0.82bbfb7c6af0c20bd17bf9a1ebb6b404.svg";
export { ForwardRef as ReactComponent };